module.exports = __webpack_public_path__ + "img/jet6_01.71160135.jpg";